// utils/apiCache.js
// The service worker (public/sw.js) caches API answers per URL so the app works
// without a connection. The URL says nothing about who asked: on a shared tablet
// the next user would read the previous user's orders and profile offline. This
// removes those answers when another user signs in.
//
// Reference data (sites, checklists, product models, the photographer list) is the
// same for everyone and stays, or a tablet could not start an order offline after
// a change of user. Only the Cache Storage is touched here; the upload queue lives
// in IndexedDB and is never part of this.

const API_CACHE_PREFIX = 'photoapp-api-';

const USER_PATHS = ['/api/auth/me', '/api/orders', '/api/notifications', '/api/photos', '/api/rd'];

export function isUserSpecificApiPath(pathname) {
  return USER_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Resolves with the number of removed entries. Never rejects: a device without
// Cache Storage has nothing to clear, and a failure here must not block a sign-in.
export async function clearUserApiCache(cacheStorage = typeof caches !== 'undefined' ? caches : null) {
  if (!cacheStorage) return 0;
  let removed = 0;
  try {
    const names = (await cacheStorage.keys()).filter((name) => name.startsWith(API_CACHE_PREFIX));
    for (const name of names) {
      const cache = await cacheStorage.open(name);
      for (const request of await cache.keys()) {
        if (isUserSpecificApiPath(new URL(request.url).pathname) && (await cache.delete(request))) removed += 1;
      }
    }
  } catch {}
  return removed;
}
